<template>
  <div class="container-fluid">
    <page-header :page="page" />
    <squareOption :menu="optionList" />
  </div>
</template>

<script>
import store from '@/store/index';
import PageHeader from 'PageHeader';
import squareOption from '@/components/common/menu/SquareOption';
import navMenuTitles from '@/utils/constants/navMenuTitles';

export default {
  components: {
    squareOption,
    PageHeader,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-cog',
        title: 'Usuario',
        routes: ['Inicio', 'Usuario'],
      },
    };
  },
  computed: {
    optionList() {
      return store.getters['$_user/getSiteMap']
        .find((x) => x.title == navMenuTitles.User)
        .children.map((item) => ({
          title: item.title,
          description: item.description,
          detail: item.detail,
          icon: item.iconClasses,
          mainImage: item.mainImagePath,
          hoverImage: item.mainImageHoverPath,
          needSelectedStudent: item.needSelectedStudent,
          route: item.navigationPath,
          trackingFlag: item.trackingFlag
        }));
    },
  },
};
</script>
